'use strict';

var model = gSTB.GetDeviceModelExt(),
    cloud = {
        report: 'https://firestore.googleapis.com/v1beta1/projects/ministra-reporter/databases/(default)/documents/report',
        webUi: 'https://ministra-reporter.firebaseapp.com/'
    },
    rocketChatUrl  = 'https://im.infomir.com/hooks/t5ojYPqBGMCqBCSFM/t74txyGGEs52Jq63A38MDFdoexWbYWPTwB4hiJSAbjLa4nxr',
    tracking       = [],
    trackActivated = false,
    originalDebug, ip;

// send data to the cloud
function sendReport ( data, callback ) {
    var xhr = new XMLHttpRequest();

    callback = callback || function () {
        return null;
    };

    xhr.open('POST', cloud.report);
    xhr.setRequestHeader('Content-Type', 'application/json; charset=utf-8');

    xhr.onload = function () {
        if ( this.status === 200 ) {
            callback(xhr);
        } else {
            debug('reporter')('firebase response: ' + this.status + ', ' + this.statusText);
        }
    };

    xhr.send(data);
}

// prepare data for sending to the cloud
function prepareData ( data ) {
    var result = {fields: {}};

    result.fields.createTime = {
        integerValue: Date.now()
    };

    Object.keys(data).forEach(function ( field ) {
        var resultField = result.fields[field] = {};

        resultField['stringValue'] = (typeof data[field] === 'object') ?
            JSON.stringify(data[field]) :
            data[field];
    });

    return JSON.stringify(result);
}

function sendToRocketChat ( response ) {
    var xhr    = new XMLHttpRequest(),
        avatar = 'https://firebasestorage.googleapis.com/v0/b/ministra-reporter.appspot.com/o/info.png?alt=media&token=47f49512-7645-4b80-bfff-0990b8db91a4',
        color  = '#f6c342',
        type, id, appLink, message;

    response = JSON.parse(response);

    type = response.fields.type.stringValue;
    id = response.name.split('/').slice(-1).join();
    appLink = cloud.webUi + '#' + id;

    if ( type === 'track' ) {
        avatar = 'https://firebasestorage.googleapis.com/v0/b/ministra-reporter.appspot.com/o/track.png?alt=media&token=5c3aec4b-6fd6-474a-b2ea-aad0af630ada';
        color = '#67ab49';
    }

    message = {
        avatar: avatar,
        alias: type,
        attachments: [
            {
                color: color,
                fields: [{title: model + ' - ' + ip}],
                title: id,
                //eslint-disable-next-line
                title_link: appLink
            }
        ]
    };

    /*message.alias = type;
    message.text = 'model: *' + model + '*, ' +
        'ip: *' + ip + '*, ' +
        'id: *[' + id + '](' + appLink + ')*';*/

    // send message to hipChat
    xhr.open('POST', rocketChatUrl);
    xhr.setRequestHeader('Content-Type', 'application/json; charset=utf-8');

    xhr.onload = function () {
        if ( this.status === 200 ) {
            core.notify({title: 'report was send: ' + id});

            debug('reporter')(
                'model: ' + model +
                ', ip: ' + ip +
                ', type: ' + type +
                ', appLink: ' + appLink
            );
        } else {
            debug('reporter')('rocketChat response: ' + this.status + ', ' + this.statusText + ',\n ', this.responseText);
        }
    };

    xhr.send(JSON.stringify(message));
}


module.exports = {
    track: function () {
        if ( trackActivated ) {
            ip = (gSTB.RDir('IPAddress') || gSTB.RDir('WiFi_ip')).trim();

            sendReport(
                prepareData({type: 'track', body: tracking}),
                function ( xhr ) {
                    trackActivated = false;
                    debug.log = originalDebug;
                    sendToRocketChat(xhr.responseText);
                }
            );
        } else {
            debug.log('reporter tracking...');
            originalDebug = debug.log;
            debug.log = function ( text ) {
                var tag, message;

                text = text.replace(/%c/g, '');
                text = text.split(' ');
                tag = text.shift();
                message = text.join(' ');

                if ( trackActivated ) {
                    tracking.push({tag: tag, message: message});
                }
            };

            trackActivated = true;
            tracking = [];
        }
    },
    info: function () {
        var xhr          = new XMLHttpRequest(),
            api          = require('../system/api'),
            taskManager  = require('../system/task.manager'),
            pluginLoader = require('../kernel/plugin.loader'),
            configUrl    = require('./config').url,
            info, objectName;

        ip = (gSTB.RDir('IPAddress') || gSTB.RDir('WiFi_ip')).trim();

        info = {
            config: {},
            device: {
                model: model,
                serialNumber: gSTB.GetDeviceSerialNumber(),
                vendor: gSTB.GetDeviceVendor(),
                versionHardware: gSTB.GetDeviceVersionHardware(),
                activeBank: gSTB.GetDeviceActiveBank(),
                imageDescription: gSTB.GetDeviceImageDesc(),
                imageVersion: gSTB.GetDeviceImageVersion(),
                imageVersionCurrent: gSTB.GetDeviceImageVersionCurrent(),
                mac: gSTB.GetDeviceMacAddress(),
                ip: ip,
                environment: core.environment,
                api: {}
            },
            runtime: {
                apps: [],
                plugins: [],
                runHistory: [],
                requests: null
            }
        };

        for ( objectName in api ) {
            if ( objectName !== 'stbEvent' && typeof window[objectName] !== 'undefined' ) {
                info.device.api[objectName] = {};
                /* eslint no-loop-func: 0 */
                Object.keys(api[objectName]).forEach(function ( property ) {
                    var value = api[objectName][property];

                    if ( typeof value === 'function' ) {
                        info.device.api[objectName][property] = 'function';
                    } else if ( typeof value === 'object' && value !== null ) {
                        info.device.api[objectName][property] = Object.keys(value);
                    } else {
                        info.device.api[objectName][property] = api[objectName][property];
                    }
                });
            }
        }

        if ( core.backend ) {
            info.runtime.requests = core.backend.requests;
        }

        xhr.open('GET', configUrl);

        xhr.onload = function () {
            if ( this.status === 200 ) {
                info.config = JSON.parse(this.responseText);
                info.runtime.runHistory = taskManager.runHistory;

                Object.keys(taskManager.apps).forEach(function ( pid ) {
                    var app = taskManager.apps[pid];

                    info.runtime.apps.push({
                        name: app.config.name,
                        src: app.$iframe.src
                    });
                });

                Object.keys(pluginLoader.loaded).forEach(function ( pkgName ) {
                    info.runtime.plugins.push(pluginLoader.loaded[pkgName]);
                });

                sendReport(
                    prepareData({type: 'info', body: info}),
                    function ( request ) {
                        sendToRocketChat(request.responseText);
                    }
                );
            } else {
                debug('reporter')('get config response: ' + this.status + ', ' + this.statusText);
            }
        };

        xhr.send();
    }
};
